import { ReasoningStep } from '../store/dashboard/askAica/actions';

/**
 * Builds the in-flight turn's reasoning message from `steps` — the FULL list
 * of reasoning steps generated so far, which Athena sends on every reasoning
 * frame (live: `state.reasoning_steps`; re-attach: the buffer folder's
 * cumulative `self.reasoning`). Each step's own text already carries its
 * trailing separator, so joining them with no separator of our own is what
 * reconstructs the original multi-line message (see chat_service.py's
 * `_describe_reasoner_tool_calls` / reasoner-iteration call sites).
 *
 * Takes no "current" accumulator: `steps` is always authoritative on its own,
 * so there is nothing to merge onto. A re-attach's one compacted catch-up
 * frame can carry several new steps in a single call — taking only the
 * previous "last step" there silently dropped every earlier step in that
 * batch (RECUR-28136).
 *
 * Shared by both the leads (store/dashboard/askAica) and portfolio
 * (store/globalAskAica) reducers' setReasoning handlers so the accumulation
 * formula only has one place to fix. Callers check isEmpty/hasNewReasoning
 * before calling this helper — it is never called with nothing new to show.
 */
export const accumulateReasoning = (steps: ReasoningStep[]): ReasoningStep => {
    const latestReasoning = steps[steps.length - 1];
    return { ...latestReasoning, message: steps.map((step) => step.message).join('') };
};
